import dayjs, { Dayjs } from 'dayjs';

export const addWorkdays = (startDate: Dayjs | Date | string | number, days: number): Dayjs => {
    let date = dayjs(startDate); // use a clone
    while (days > 0) {
        date = date.add(1, 'day');
        // decrease "days" only if it's a weekday.
        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
            days -= 1;
        }
    }

    return date;
};
